export const namespaced = true;

export const state = {
  isLoading: false,
};

export const mutations = {
  SHOW_LOADING(state) {
    state.isLoading = true;
  },
  HIDE_LOADING(state) {
    state.isLoading = false;
  },
};

export const actions = {
  showLoading({ commit }) {
    commit('SHOW_LOADING');
  },
  hideLoading({ commit }) {
    commit('HIDE_LOADING');
  },
};
